import { Reveal, SectionLabel, Icon } from "./ui";
import RichHTML from "../RichHTML";
import { Check } from "lucide-react";

export default function Leistungen({ items = [], index, appr }) {
  return (
    <section id="leistungen" style={appr?.style} className={`py-20 lg:py-28 ${appr?.dark ? "mf-section-dark" : ""}`}>
      <div className="mf-container">
        <Reveal><SectionLabel index={index}>Leistungen</SectionLabel></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-head font-light tracking-tight text-[1.875em] lg:text-[2.6em] leading-tight mt-6 text-[var(--mf-ink)] max-w-2xl">
            Vier Bereiche, <span className="font-medium">ein Ansprechpartner</span>.
          </h2>
        </Reveal>

        <div className="mt-16 flex flex-col gap-16 lg:gap-24">
          {items.map((s, i) => {
            const flip = i % 2 === 1;
            return (
              <Reveal key={s.id || i}>
                <div
                  data-testid={`leistung-${i}`}
                  className="grid lg:grid-cols-2 gap-8 lg:gap-14 items-stretch"
                >
                  {/* media */}
                  <div className={`${flip ? "lg:order-2 " : ""}h-full`}>
                    {s.image ? (
                      <div className="relative h-[220px] lg:h-full overflow-hidden group">
                        <img
                          src={s.image}
                          alt={s.title}
                          className="absolute inset-0 w-full h-full object-cover grayscale-[0.2] group-hover:grayscale-0 transition-all duration-700"
                        />
                        <div className="absolute inset-0 ring-1 ring-inset ring-black/5" />
                        <div className="absolute top-4 left-4 bg-white/95 backdrop-blur w-11 h-11 flex items-center justify-center">
                          <Icon name={s.icon} size={22} className="text-[var(--mf-red)]" />
                        </div>
                      </div>
                    ) : (
                      <div className="relative h-[220px] lg:h-full min-h-[220px] bg-[var(--mf-ink)] flex items-center justify-center mf-grain overflow-hidden">
                        <Icon name={s.icon} size={90} strokeWidth={0.9} className="text-white/25" />
                      </div>
                    )}
                  </div>

                  {/* text */}
                  <div className={flip ? "lg:order-1" : ""}>
                    <div className="font-head text-sm font-semibold text-[var(--mf-red)]">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    <h3 className="font-head font-bold text-[1.5em] lg:text-[1.875em] tracking-tight mt-2 text-[var(--mf-ink)]">
                      {s.title}
                    </h3>
                    <div className="mt-4 text-[1em] text-[var(--mf-ink-soft)] leading-relaxed"><RichHTML html={s.description} /></div>
                    <ul className="mt-6 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                      {(s.bullets || []).map((b, bi) => (
                        <li key={bi} className="flex items-start gap-2.5 text-[0.875em] text-[var(--mf-ink)]">
                          <Check size={16} className="text-[var(--mf-red)] mt-0.5 shrink-0" strokeWidth={2.6} />
                          <span>{b}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
